/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { useQuery, gql } from '@apollo/client';
import { handleApolloError } from '@exo/frontend-common-apollo';

export const useRecalculateCartPrice = (cartId, fetchPolicy, updatePrices?, checkoutType?, calculateParams?) => {
  const variables = {
    cartId,
    updatePrices,
    checkoutType,
    calculateParams
  };

  const RECALCULATE_PRICE_GQL = gql`
  query RecalculateCart($cartId: String, $updatePrices: Boolean, $checkoutType: String, $calculateParams: CalculateParams) {
  recalculateCart(cartId: $cartId, updatePrices: $updatePrices, checkoutType: $checkoutType, calculateParams: $calculateParams) {
    cartId
    success
  }
}
  `;

  const { loading, error, data, refetch } = useQuery(RECALCULATE_PRICE_GQL, {
    variables,
    ...(fetchPolicy ? { fetchPolicy } : {}),
    context:{clientName:"cart"}
  });

  handleApolloError(__filename, error);

  return { error, loading, data, refetch };
};
